import { FC, useReducer, ChangeEvent } from 'react';
import { Container, ShowPassword } from './ChangePassword.styles';
import { Button, Input, Section } from '../../../../components';
import { SectionTitle, Separator, Form } from '../../MyAccount.styles';
import { KeyOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import { changePasswordReducer, changePasswordFormInitialState } from './forms/changePassword.form';
import { useToastStore, useUserStore } from '../../../../stores';
import { postUserPassword } from '../../../../services';

const ChangePassword: FC = () => {
	const { user } = useUserStore();
	const { setToast } = useToastStore();
	const [state, dispatch] = useReducer(changePasswordReducer, changePasswordFormInitialState);

	const handleInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
		const { name, value } = e.target;
		dispatch({ type: 'SET_VALUE', field: name, payload: value });
	};

	const handleTogglePasswordVisibility = (field: string): void => {
		dispatch({ type: 'TOGGLE_SHOW_PASSWORD', field });
	};

	const handleChangePassword = async () => {
		const body = {
			idUsuario: user!.id,
			senhaAntigo: state.oldPassword.value,
			senhaNova: state.newPassword.value,
		};

		try {
			await postUserPassword(body);
			setToast({ message: 'Senha alterada com sucesso!', variant: 'success' });
		} catch {
			setToast({ message: 'Erro ao alterar a senha!', variant: 'error' });
		}
	};

	return (
		<Container>
			<Section>
				<SectionTitle>Alterar Senha</SectionTitle>
				<Separator />
				<Form>
					<Input
						variant='text'
						label='Senha Antiga'
						className='full-line'
						name='oldPassword'
						value={state.oldPassword.value}
						onChange={handleInputChange}
						icon={
							<ShowPassword
								type='button'
								onClick={() => handleTogglePasswordVisibility('oldPassword')}
							>
								{state.oldPassword.showPassword ? <Visibility /> : <VisibilityOff />}
							</ShowPassword>
						}
						type={state.oldPassword.showPassword ? 'text' : 'password'}
					/>
					<Input
						variant='text'
						label='Nova Senha'
						className='full-line'
						name='newPassword'
						value={state.newPassword.value}
						onChange={handleInputChange}
						icon={
							<ShowPassword
								type='button'
								onClick={() => handleTogglePasswordVisibility('newPassword')}
							>
								{state.newPassword.showPassword ? <Visibility /> : <VisibilityOff />}
							</ShowPassword>
						}
						type={state.newPassword.showPassword ? 'text' : 'password'}
					/>{' '}
					<Input
						variant='text'
						label='Confirmação da Nova Senha'
						className='full-line'
						name='confirmNewPassword'
						value={state.confirmNewPassword.value}
						onChange={handleInputChange}
						icon={
							<ShowPassword
								type='button'
								onClick={() => handleTogglePasswordVisibility('confirmNewPassword')}
							>
								{state.confirmNewPassword.showPassword ? <Visibility /> : <VisibilityOff />}
							</ShowPassword>
						}
						type={state.confirmNewPassword.showPassword ? 'text' : 'password'}
					/>
					<Button
						disabled={
							!state.oldPassword.value ||
							!state.newPassword.value ||
							!state.confirmNewPassword.value
						}
						onClick={handleChangePassword}
						variant='contained'
						fitContent
					>
						<KeyOutlined fontSize='medium' />
						<span>Atualizar</span>
					</Button>
				</Form>
			</Section>
		</Container>
	);
};

export default ChangePassword;
